module.exports = __webpack_public_path__ + "res/img/male.61dd0dc9.png";